/**
 * Кошик людини (DAT-05; trash.html, кадри В–Г): `/trash?entity=<ключ>` — лінивий чанк
 * `platform/trash/TrashPage.tsx`. Ключ сутності — лише канонічний (`[a-z][a-z0-9_]*`), інше
 * адреса відкидає: сторінка тоді відкриває першу вкладку.
 */
import { createRoute } from '@tanstack/react-router';
import { TRASH_PATH } from '../../shell/nav-model.ts';
import { rootRoute } from './root.tsx';

export interface TrashSearch {
  entity?: string;
}

const ENTITY_KEY = /^[a-z][a-z0-9_]{0,62}$/;

export const trashRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: TRASH_PATH,
  validateSearch: (search: Record<string, unknown>): TrashSearch =>
    typeof search.entity === 'string' && ENTITY_KEY.test(search.entity)
      ? { entity: search.entity }
      : {},
}).lazy(() => import('../../platform/trash/TrashPage.tsx').then((m) => m.TrashRoute));
